// How the make is delivered; "auto" lets the model choose
export const OUTPUTS = [
  { id: "auto", label: "Auto", icon: "wand-magic-sparkles" },
  { id: "text", label: "Text", icon: "align-left" },
  { id: "docx", label: "Word", icon: "file-word" },
  { id: "pdf", label: "PDF", icon: "file-pdf" },
  { id: "xlsx", label: "Spreadsheet", icon: "file-excel" },
  { id: "pptx", label: "Slides", icon: "file-powerpoint" },
  { id: "image", label: "Image", icon: "image" },
];

// The shape of an image make; "auto" lets the image model decide
export const IMAGE_SHAPES = [
  { id: "auto", label: "Auto" },
  { id: "square", label: "Square" },
  { id: "portrait", label: "Portrait" },
  { id: "landscape", label: "Landscape" },
];

export default {
  name: "output",
  namespaced: true,
  state: {
    activeOutput: "auto",
    imageShape: "auto",
  },
  mutations: {
    SET_ACTIVE_OUTPUT(state, payload) {
      state.activeOutput = payload;
    },
    SET_IMAGE_SHAPE(state, payload) {
      state.imageShape = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("SET_ACTIVE_OUTPUT", "auto");
      commit("SET_IMAGE_SHAPE", "auto");
    },
    selectOutput({ commit }, output) {
      if (OUTPUTS.some((option) => option.id === output)) {
        commit("SET_ACTIVE_OUTPUT", output);
      }
    },
    selectImageShape({ commit }, shape) {
      if (IMAGE_SHAPES.some((option) => option.id === shape)) {
        commit("SET_IMAGE_SHAPE", shape);
      }
    },
  },
  getters: {},
};
